import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { ABCisTableModel, ColumnType } from 'src/app/components/abcis-table/abcis-table.component';
import { ABCisApi } from 'src/app/handlers/apiHandler.service';

@Component({
  selector: 'document-history',
  standalone: false,
  templateUrl: './document-history.component.html',
  styleUrls: ['./document-history.component.scss']
})
export class DocumentHistoryComponent implements OnInit, OnChanges {
  @Input() documentID: number;
  hasConfigured = false;
  tableConfig: ABCisTableModel = undefined;

  constructor() { }

  ngOnInit() {
    if (this.documentID != undefined) {
      this.setConfiguration();
    } else {
      this.hasConfigured = false;
    }
  }

  ngOnChanges() {
    if (this.documentID != undefined) {
      this.setConfiguration();
    } else {
      this.hasConfigured = false;
    }
  }

  refreshHistory() {
    // Force the table to reload by resetting the configuration
    this.hasConfigured = false;
    setTimeout(() => {
      this.setConfiguration();
    }, 0);
  }

  setConfiguration() {
    // Route the users filter results. For sharing
    this.tableConfig = {
      apiConfig: {
        api: ABCisApi.Support,
        table: 'null',
        url: `document/${this.documentID}/history`,
        approxamateRowCount: 1000,
        anyParams: true
      },
      colConfig: [
        { field: 'ocrProcessHistoryId', header: 'History ID', type: ColumnType.String, isPrimary: true },
        { field: 'documentId', header: 'Document ID', type: ColumnType.String },
        { field: 'jobId', header: 'Job ID', type: ColumnType.DropDown, setUrl:'job/lookup' },
        { field: 'channelId', header: 'Channel ID', type: ColumnType.DropDown, setUrl:'channel/lookup' },
        { field: 'priority', header: 'Priority', type: ColumnType.String },
        { field: 'ocrClientId', header: 'OCR Client ID', type: ColumnType.DropDown, setUrl:'client/lookup' },
        { field: 'ocrStatusId', header: 'OCR Status ID', type: ColumnType.DropDown, setUrl:'status/lookup' },
        { field: 'updatedAt', header: 'Updated At', type: ColumnType.Date }
      ],
      isConfigurable: false,
      isTable: false,
      isFilterable: false
    };
    this.hasConfigured = true;
  }
}
